import { Typography } from '@material-ui/core'

import { getTranslate } from '../../localization'
import useStyles from './styles/RatePlansPoliciesActionModalTableHead.styles'

const RatePlansPoliciesActionModalTableHead = () => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div>
        <Typography variant="body1">{getTranslate('Priority')}</Typography>
      </div>
      <div>
        <Typography variant="body1">
          {getTranslate('Penalty Amount')}
        </Typography>
      </div>
      <div>
        <Typography variant="body1">{getTranslate('Penalty Type')}</Typography>
      </div>
      <div>
        <Typography variant="body1">
          {getTranslate('Deadline (hrs)')}
        </Typography>
      </div>
      <div>
        <Typography variant="body1">
          {getTranslate('Deadline Time Offset')}
        </Typography>
      </div>
      <div>
        <Typography variant="body1">{getTranslate('Type')}</Typography>
      </div>
    </div>
  )
}
export default RatePlansPoliciesActionModalTableHead
